import React, { Component } from 'react';
import LabHome from './Home';
import { Box, Typography, Paper } from "@mui/material";
import { CommonNavigationHeader } from '../../../Components/Common Components/CommonComponents';
import Status from '../Home/Status';
import TestReport from './TestReport';
import Avatar from '@mui/material/Avatar';
import { ImagePaths } from '../../../Utility/ImagePaths';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { clearCachevalue, localGetItem, setCachevalue, localSetItem } from '../../../Utility/Services/CacheProviderService';
import { withTranslation } from 'react-i18next';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import { hasAccess } from '../../../Utility/AccessUtils';
import ForTechnicians from './ForTechnicians';
import OutsourceList from './OutsourceList';
import LabCancelledBill from './LabCancelledBill';
import LabCreateOrder from '../../FrontOffice/Billing/CommonBilling/LabBillingOrder/LabCreateOrder';
import LabOrderIndex from '../../FrontOffice/Billing/CommonBilling/LabBillingOrder/LabOrderIndex';
import LabApprovalList from './LabApprovalList';
import RecheckRejectList from './RecheckRejectList';

class MainHome extends Component {
    constructor(props) {
        super(props);
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        const isNewBilling = localGetItem("isNewBilling") === 'true' ? "Status" : "LabHome"
        const isLabResultApprovalEnabled = localGetItem("enable_lab_result_approval") === 'true' && (loggedInUserInfo?.is_branch_admin || loggedInUserInfo?.is_super_admin)
        const userAccess = loggedInUserInfo?.permission_access?.lab?.lab_approver && loggedInUserInfo?.is_user && localGetItem("enable_lab_result_approval") === 'true'
        const approvalTabs = (isLabResultApprovalEnabled || userAccess) ? [
            { id: 5, TabName: "Approval List", value: "ApprovalList", content: <LabApprovalList/> },
            { id: 6, TabName: "Recheck / Reject List", value: "RecheckRejectList", content: <RecheckRejectList /> },
        ] : [];
        this.state = {
            isNewBilling,
            navigationHeaderList: localGetItem("isNewBilling") === 'true'
                ? [
                    { id: 0, TabName: "Status", value: "Status", content: <Status /> },
                    { id: 1, TabName: "Test Report", value: "TestReport", content: <LabHome /> },
                    { id: 2, TabName: "For Technicians", value: "ForTechnicians", content: <ForTechnicians /> },
                    { id: 3, TabName: "Outsource List", value: "OutsourceList", content: <OutsourceList /> },
                    { id: 4, TabName: "Order", value: "Order", content: <LabCreateOrder /> },
                    ...approvalTabs,
                ]
                : [
                    { id: 0, TabName: "Create Bill", value: "LabHome", content: <LabHome /> },
                    { id: 1, TabName: "Status", value: "Status", content: <Status /> },
                    { id: 2, TabName: "Test Report", value: "TestReport", content: <LabHome /> },
                    { id: 3, TabName: "For Technicians", value: "ForTechnicians", content: <ForTechnicians /> },
                    { id: 4, TabName: "Outsource List", value: "OutsourceList", content: <OutsourceList /> },
                    { id: 5, TabName: "Cancelled Bill", value: "CancelledBill", content: <LabCancelledBill /> },
                ],
            selectedScreen: props.location?.state?.selectedScreen ? props.location?.state.selectedScreen : isNewBilling,
            savedBillDetails: {},
            searchPatientDetails: [],
            statusDetailList: {},
            isPatientSearch: true,
            selectedPatientDetails: {},
            search_key: "",
            selectedTabID: props.location?.state?.selectedTabID ? props.location?.state.selectedTabID :0,
            isTabNavigation: false,
            savedTransmitList:{},
            labType: "",
            clinic_id : null,
            isTestReport: false,
            selectedPatientDatas:this.props.history?.location?.state?.selectedPatientData ? this.props.history?.location?.state?.selectedPatientData : {},
            NewLogin: false,
            selectedLabPatient: null,
            fromResult:this.props.history?.location?.state?.fromResultSaved ? this.props.history?.location?.state?.fromResultSaved : false,
            labApprovalListCount: 0,
            labRecheckRejectListCount: 0
        };
    }

    // Fetch counts for Approval List and Recheck/Reject List tabs (same APIs as LabApprovalList.js and RecheckRejectList.js)
    fetchLabTabCounts = () => {
        const hasApprovalTabs = (this.state.navigationHeaderList || []).some(t => t.value === "ApprovalList" || t.value === "RecheckRejectList");
        if (!hasApprovalTabs) return;
        RestAPIService.getAll(Serviceurls.LAB_RESULT_APPROVER)
            .then((response) => {
                if (response.data.status === 'success') {
                    const count = (response.data.data || []).length;
                    this.setState({ labApprovalListCount: count });
                }
            })
            .catch(() => {});
        RestAPIService.getAll(Serviceurls.LAB_RESULT_HISTORY)
            .then((response) => {
                if (response.data.status === 'success') {
                    const count = (response.data.data || []).length;
                    this.setState({ labRecheckRejectListCount: count });
                }
            })
            .catch(() => {});
    };

    buildNavigationHeaderList = () => {
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const isNewBilling = localGetItem("isNewBilling") === 'true';
        const isLabResultApprovalEnabled = localGetItem("enable_lab_result_approval") === 'true' && (loggedInUserInfo?.is_branch_admin || loggedInUserInfo?.is_super_admin);
        const userAccess = loggedInUserInfo?.permission_access?.lab?.lab_approver && loggedInUserInfo?.is_user && localGetItem("enable_lab_result_approval") === 'true';
        const approvalTabs = (isLabResultApprovalEnabled || userAccess) ? [
            { id: 5, TabName: "Approval List", value: "ApprovalList", content: <LabApprovalList/> },
            { id: 6, TabName: "Recheck / Reject List", value: "RecheckRejectList", content: <RecheckRejectList/> },
        ] : [];
        return isNewBilling
            ? [
                { id: 0, TabName: "Status", value: "Status", content: <Status /> },
                { id: 1, TabName: "Test Report", value: "TestReport", content: <LabHome /> },
                { id: 2, TabName: "For Technicians", value: "ForTechnicians", content: <ForTechnicians /> },
                { id: 3, TabName: "Outsource List", value: "OutsourceList", content: <OutsourceList /> },
                { id: 4, TabName: "Order", value: "Order", content: <LabCreateOrder /> },
                ...approvalTabs,
            ]
            : [
                { id: 0, TabName: "Create Bill", value: "LabHome", content: <LabHome /> },
                { id: 1, TabName: "Status", value: "Status", content: <Status /> },
                { id: 2, TabName: "Test Report", value: "TestReport", content: <LabHome /> },
                { id: 3, TabName: "For Technicians", value: "ForTechnicians", content: <ForTechnicians /> },
                { id: 4, TabName: "Outsource List", value: "OutsourceList", content: <OutsourceList /> },
                { id: 5, TabName: "Cancelled Bill", value: "CancelledBill", content: <LabCancelledBill /> },
            ];
    };

    // Helper function to check access for lab home tabs
    // Uses hasAccess from AccessUtils for simplified package-based access control
    checkLabHomeTabAccess = (tabName) => {
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const role = loggedInUserInfo?.is_super_admin ? "admin" : (loggedInUserInfo?.is_branch_admin ? "admin" : "user");
        
        // Map tab names to routes for hasAccess check
        const tabRouteMap = {
            "Create Bill": "/MainHome/CreateBill",
            "Status": "/MainHome/Status",
            "Test Report": "/MainHome/TestReport",
            "For Technicians": "/MainHome/ForTechnicians",
            "Outsource List": "/MainHome/OutsourceList",
            "Cancelled Bill": "/MainHome/CancelledBill",
            "Order": "/MainHome/Order",
            "Approval List": "/MainHome/ApprovalList",
            "Recheck / Reject List": "/MainHome/RecheckRejectList"
        };
        
        const route = tabRouteMap[tabName];
        
        // For users, also check CheckAccessFunc for user-level permissions
        if (role === "user") {
            const checkAccessResult = CheckAccessFunc("Laboratory", "Home", tabName, null, "Tab");
            if (checkAccessResult?.viewAccess === false) {
                return {
                    viewAccess: false,
                    is_locked: checkAccessResult?.is_locked || false
                };
            }
        }
        
        // Use hasAccess for package-based access control
        if (route) {
            const accessResult = hasAccess(null, role, route);
            return {
                viewAccess: accessResult.allowed,
                is_locked: accessResult.locked
            };
        }
        
        // Fallback to CheckAccessFunc if no route mapping
        const checkAccessResult = CheckAccessFunc("Laboratory", "Home", tabName, null, "Tab");
        return {
            viewAccess: checkAccessResult?.viewAccess !== false,
            is_locked: checkAccessResult?.is_locked || false
        };
    }

    componentDidMount(){
        this.props.changeScreen('1')
        let subScreen = this.state.selectedScreen == "Status" ? "Status" : this.state.selectedScreen === "TestReport" ? "TestReport" : this.state.isNewBilling
        this.props.subScreenChange(subScreen)
        if(localGetItem("isLoggedIn")){
            let loginProfile = localGetItem("loggedInUserInfo");
            let user = JSON.parse(loginProfile)
            this.setState({
                labType : user.laboratory_type
            })
        }
        // Fetch custom config so tabs (e.g. Approval List) show on first render; Muidrawer may not have finished yet.
        RestAPIService.getAllTwo(Serviceurls.CUSTOM_CONFIG)
            .then((response) => {
                if (response.data.status === "success" && response.data.data) {
                    localSetItem('enable_lab_result_approval', response.data.data?.enable_lab_result_approval || false);
                    const navigationHeaderList = this.buildNavigationHeaderList();
                    this.setState({ navigationHeaderList }, () => {
                        this.fetchLabTabCounts();
                        const filteredTabs = this.getFilteredNavigationTabs();
                        if (filteredTabs.length > 0 && !filteredTabs.find(t => t.value === this.state.selectedScreen)) {
                            this.setState({ selectedScreen: filteredTabs[0].value, selectedTabID: 0 });
                        }
                    });
                }
            })
            .catch(() => {})
        // Ensure selected screen is valid for filtered tabs (for users)
        const filteredTabs = this.getFilteredNavigationTabs();
        if (filteredTabs.length > 0 && !filteredTabs.find(t => t.value === this.state.selectedScreen)) {
            this.setState({
                selectedScreen: filteredTabs[0].value,
                selectedTabID: 0
            });
        }
    }
    
    // Get filtered navigation tabs based on user access; merges counts for Approval List and Recheck/Reject List
    getFilteredNavigationTabs = () => {
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const isAdmin = loggedInUserInfo?.is_super_admin || loggedInUserInfo?.is_branch_admin;
        const list = this.state.navigationHeaderList || [];

        const mergeCounts = (tabs) => tabs.map((tab, index) => {
            const base = { ...tab, id: index };
            if (tab.value === "ApprovalList") return { ...base, count: this.state.labApprovalListCount };
            if (tab.value === "RecheckRejectList") return { ...base, count: this.state.labRecheckRejectListCount };
            return base;
        });

        if (isAdmin) return mergeCounts(list);

        const filteredTabs = list.filter(tab => {
            const access = this.checkLabHomeTabAccess(tab.TabName);
            return access?.viewAccess !== false && access?.is_locked !== true;
        });
        return mergeCounts(filteredTabs);
    }
    
    // Get the correct selected tab ID based on filtered tabs
    getFilteredSelectedTabID = (filteredTabs) => {
        const currentTabIndex = filteredTabs.findIndex(t => t.value === this.state.selectedScreen);
        return currentTabIndex >= 0 ? currentTabIndex : 0;
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props 
        if(location?.state && location?.state?.savedBillDetails){
            if(this.state.savedBillDetails != location.state.savedBillDetails) { 
            var { savedBillDetails } = location.state
            this.setState({
                savedBillDetails:  savedBillDetails,
                selectedScreen: this.state.isNewBilling,
                selectedTabID: 0,
                isTestReport: false
            })
           }
        }
        if(location && location.state && location.state.clinic_id){
            if(this.state.clinic_id != location.state.clinic_id){
                let {clinic_id} = location.state
                this.setState({
                    clinic_id : clinic_id
                })
            }
        }
        if(location && location.state && location.state.NewLogin){
            if(this.state.NewLogin != location.state.NewLogin){
                let {NewLogin} = location.state
                this.setState({
                    NewLogin : NewLogin
                }, () => {
                    if(this.state.NewLogin) {
                        // this.props.getSavedBillStatus(true)
                        // this.props.getTransmitBillCount(true)
                    }
                })
            }
        }
        if(location?.state && location?.state?.savedTransmitList){
            if(this.state.savedTransmitList !== location.state.savedTransmitList){
                let {savedTransmitList} = location.state
                this.setState({
                    savedTransmitList : savedTransmitList,
                    selectedScreen: this.state.isNewBilling,
                    selectedTabID:0,
                    isTestReport: false
                })
            }
        }
        if( (location && location.state && location.state.search_key) || (location.state && location.state.search_key == "") ) {
            if(this.state.search_key != location.state.search_key) { 
             this.setState({
                search_key: location.state.search_key ? location.state.search_key : "" ,
                isTestReport: false
             }, () => {
                 if(this.state.search_key == "" && this.state.selectedScreen == this.state.isNewBilling) {
                     this.setState({
                        searchPatientDetails: []
                     })
                 } else {
                    if(this.state.selectedScreen == this.state.isNewBilling) {
                        this.searchPatientDetails(this.state.search_key)
                    } 
                 }
             })
            } 
        }  

        if(this.props.history?.location?.state?.selectedPatientData && prevProps !== this.props){
            if(this.state.selectedPatientDatas !== this.props.history?.location?.state?.selectedPatientData){
                let details = this.props.history?.location?.state?.selectedPatientData
                this.setState({
                    selectedLabPatient:details ? details.patient_id : null
                    
                }, ()=>{ this.props.history.push({ state: {} }) })
            }
        }
        if(this.props.history?.location?.state?.Patient_ID && prevProps !== this.props){
                let details = this.props.history?.location?.state?.Patient_ID
                this.setState({
                    selectedLabPatient:details ? details : null
                }, ()=>{ this.props.history.push({ state: {} }) })
        }
    }
    searchPatientDetails = (search_key) => {
        var search_key = search_key ? search_key : ""
        let serviceUrl = ""
        if( this.state.labType == "Standalone Laboratory") {
               serviceUrl = Serviceurls.LAB_SEARCH_PATIENT + "?search_key=" + search_key
        } else {
               serviceUrl = Serviceurls.LAB_PATIENT_TRANSMIT_SEARCH + "?search_key=" + search_key

        }
        RestAPIService.getAll(serviceUrl)
            .then(response => {
                if (response.data.status == "success") {
                    var data = response.data.data
                    this.setState({
                        searchPatientDetails: data,
                        isPatientSearch: true
                    });
                } else if (response.data.status == "fail") {
                    // this.showToastBox(true, response.data.message, Constants.ErrorToast)
                }
            })
            .catch(e => {
                //  this.showToastBox(true, e.response.data.message, Constants.ErrorToast)
            });
      }
    NavigateScreen (id) {
        const filteredTabs = this.getFilteredNavigationTabs();
        if(id === 0){
            const { history } = this.props
            history.push({ pathname: "/MainHome" })
        }
        this.setState({
            selectedScreen: filteredTabs[id]?.value,
            selectedTabID: id,
            isTabNavigation: true
        },() => {
           if(this.state.isTabNavigation) {
            this.setState({
                statusDetailList: {}
            })
           }
        })
        this.props.subScreenChange(filteredTabs[id]?.value)
        this.fetchLabTabCounts();
    }
    selectedTab = ( value, statusDetailList, isReceive, isTestReport) => {
        this.props.subScreenChange(this.state.isNewBilling)
        this.props.getSavedBillStatus(true)
        this.props.getTransmitBillCount(true)
        this.props.triggerNotifyCount(true)
        this.setState({
            selectedScreen: this.state.isNewBilling,
            statusDetailList: statusDetailList,
            selectedTabID: 0,
            isTabNavigation: isReceive == "isReceivePayment" ? false : null,
            isTestReport: isTestReport
        })
    }
    getSavedBillStatus = (flag) => {
        this.props.getSavedBillStatus(flag)
    }
    getTransmitBillCount = (flag) => {
        this.props.getTransmitBillCount(flag)
    }
    triggerNotifyCount = (flag) => {
        this.props.triggerNotifyCount(flag)
    }

    ClearPatientData = () => {
        this.setState({
            selectedLabPatient: null,
        })
    }

    cancelBillClick = (Data) => {
        var { history } = this.props
        if(Data?.isForEditBill){
            setCachevalue(true, "isForCancelBill")
            setCachevalue(JSON.stringify({ ForCancel: true, cancelBillData: Data, FromStatus: true, isForEditBill : true }), "LabCancelBilldata")
            history.push({ pathname: "/Billing/LabBilling", state: { ForCancel: true, cancelBillData: Data, isForEditBill : true } })
        }else{
            setCachevalue(true, "isForCancelBill")
            setCachevalue(JSON.stringify({ ForCancel: true, cancelBillData: Data, FromStatus: true }), "LabCancelBilldata")
            history.push({ pathname: "/Billing/LabBilling", state: { ForCancel: true, cancelBillData: Data } })
        }
    }
    
    ReceivePaymentClick = (Data) => {
        this.props?.history?.push({ pathname: "/LabBilling/CashCounter", states: { patient_details: { ...Data, patient_account_number: Data?.patient__patient_account_number }, return_path: "/MainHome", back_button_lable: "Back to Status", module: Data?.ip_admission_id ? "ip" : Data?.appointment_id ? "op" : "self" } })
    }

    // Helper to render lock screen for admin
    renderLockScreen = () => {
        return (
            <Box sx={{ height: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white' }}>
                <img src={ImagePaths.LockScreen.default} alt="Lock" />
                <Typography sx={{ marginTop: '1vw', fontSize: '1.2vw', fontWeight: 600 }}>This feature is locked.</Typography>
                <Typography sx={{ marginTop: '0.5vw', fontSize: '0.9vw', color: '#666' }}>Please contact your administrator to unlock this feature.</Typography>
            </Box>
        );
    }

    // Helper to render content based on access
    renderLabHomeContent = () => {
        const { selectedScreen } = this.state;
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const isAdmin = loggedInUserInfo?.is_super_admin || loggedInUserInfo?.is_branch_admin;
        
        // Map screen to tab name for access check
        const screenToTabMap = {
            "LabHome": "Create Bill",
            "Status": "Status",
            "TestReport": "Test Report",
            "ForTechnicians": "For Technicians",
            "OutsourceList": "Outsource List",
            "CancelledBill": "Cancelled Bill",
            "Order": "Order",
            "ApprovalList": "Approval List",
            "RecheckRejectList": "Recheck / Reject List"
        };
        
        const tabName = screenToTabMap[selectedScreen];
        
        // For admin: check if tab is locked and show lock screen
        if (isAdmin && tabName) {
            const access = this.checkLabHomeTabAccess(tabName);
            if (access?.is_locked === true) {
                return <>{this.renderLockScreen()}{clearCachevalue('filteredData')}</>;
            }
        }
        
        // Render the actual component (for users, locked tabs are already hidden)
        switch (selectedScreen) {
            case "LabHome":
                return <>
                    <LabHome
                        savedBillDetails={this.state.savedBillDetails}
                        selectedPatientDetails={this.state.selectedPatientDatas ? this.state.selectedPatientDatas : this.state.selectedPatientDetails}
                        statusDetailList={this.state.statusDetailList}
                        savedTransmitList={this.state.savedTransmitList}
                        clinic_id={this.props.clinic_id}
                        isTestReport={this.state.isTestReport}
                        getSavedBillStatus={this.getSavedBillStatus}
                        getTransmitBillCount={this.getTransmitBillCount}
                        selectedLabPatient={this.state.selectedLabPatient}
                        ClearPatientData={this.ClearPatientData}
                    />
                    {clearCachevalue('filteredData')}
                </>;
            case "Status":
                return <>
                    <Status
                        selectedTab={this.selectedTab}
                        search_key={this.state.search_key}
                        getSavedBillStatus={this.getSavedBillStatus}
                        getTransmitBillCount={this.getTransmitBillCount}
                        cancelBillClick={this.cancelBillClick}
                        ReceivePaymentClick={this.ReceivePaymentClick}
                        clinic_id={this.props.clinic_id}
                    />
                    {clearCachevalue('filteredData')}
                </>;
            case "TestReport":
                return <>
                    <TestReport
                        search_key={this.state.search_key}
                        selectedTab={this.selectedTab}
                        clinic_id={this.props.clinic_id}
                        ReceivePaymentClick={this.ReceivePaymentClick}
                    />
                    {clearCachevalue('filteredData')}
                </>;
            case "ForTechnicians":
                return <>
                    <ForTechnicians
                        search_key={this.state.search_key}
                        selectedTab={this.selectedTab}
                        clinic_id={this.props.clinic_id}
                        fromResultSaved={this.state.fromResult}
                    />
                    {this.state.fromResult ? null : clearCachevalue('filteredData')}
                </>;
            case "OutsourceList":
                return <>
                    <OutsourceList
                        search_key={this.state.search_key}
                        selectedTab={this.selectedTab}
                        clinic_id={this.props.clinic_id}
                        triggerNotifyCount={this.triggerNotifyCount}
                    />
                    {clearCachevalue('filteredData')}
                </>;
            case "CancelledBill":
                return <>
                    <LabCancelledBill />
                    {clearCachevalue('filteredData')}
                </>;
            case "Order":
                return <>
                    <LabOrderIndex />
                    {clearCachevalue('filteredData')}
                </>;
            case "ApprovalList":
                return <>
                <LabApprovalList />
                {clearCachevalue('filteredData')}
                </>;
            case "RecheckRejectList":
                return <>
                <RecheckRejectList />
                {clearCachevalue('filteredData')}
                </>;
            default:
                return <>{clearCachevalue('filteredData')}</>;
        }
    }
    
    render() {
        const {t} = this.props;
        const filteredTabs = this.getFilteredNavigationTabs();
        const filteredSelectedTabID = this.getFilteredSelectedTabID(filteredTabs);
        return (
            <Box className='lab_home_main_header'>
                <CommonNavigationHeader menu={filteredTabs} NavigateScreen={this.NavigateScreen.bind(this)} selectedTabID = {filteredSelectedTabID}/>
                <div className='MainLabHome' style={{ zIndex: this.state.search_key != "" && this.state.searchPatientDetails && this.state.searchPatientDetails.length > 0 && this.state.isPatientSearch ? -1000 : null }}>
                    {this.renderLabHomeContent()}
                </div>
                {this.state.search_key != "" && this.state.searchPatientDetails && this.state.searchPatientDetails.length > 0 && this.state.isPatientSearch && this.state.selectedScreen === "Status" ?
                    <div className='MainSubContainer'>
                        <Paper className={this.state.labType === "Standalone Laboratory" ?  "Patient_Details_Search"  : "Patient_Details_Search lab_rajesh"}>
                            {this.state.searchPatientDetails && this.state.searchPatientDetails.length > 0 && this.state.searchPatientDetails.map((item, index) => {
                                return (
                                    <div className='Lab_Home_Saved_Bill' >
                                        <Avatar id='eMed_IconAvatar' src={item.photo_url || item.patient_photo_url ? item.photo_url || item.patient_photo_url : ImagePaths.Default} sx={{ boxShadow: 3, minWidth: '13%', marginTop: '1vh', marginRight: '2vh', marginBottom: '1vh' }} />
                                        <div style={{ minWidth: '55%' }}>
                                            <Typography sx={{ margin: "0vw" }}>{item.first_name || item.patient_name}</Typography>
                                            <div className='search_sub_container'>
                                                <Typography className='savedTextLight' sx={{ fontSize: "0.8vw" }}>{item.mobile_number || item.patient_mobile_number}</Typography>
                                                <Typography className='savedTextLight' sx={{ fontSize: "0.8vw", marginLeft: "0.5vw" }}>{" | " + item.patient_account_number ? item.patient_account_number : ""}</Typography>
                                            </div>                     
                                        </div>
                                        <button size="small" className='Lab_Search_Button' onClick={() => {
                                            this.setState({
                                                selectedPatientDetails: item,
                                                isTestReport: false
                                            }, () => {
                                                this.props.isSearchClear(true)
                                                this.setState({
                                                    searchPatientDetails: []
                                                })
                                            })
                                        }}><p className='Lab_saved_Bill_Text'>{t("Proceed")}</p></button>
                                    </div>
                                )
                            })
                            }

                        </Paper>
                    </div>
                    : null}
            </Box>
        )
    }

}
export default withTranslation()(MainHome);